"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var fa_1 = require("react-icons/fa");
var react_redux_1 = require("react-redux");
var react_i18next_1 = require("react-i18next");
var actions_1 = require("../../store/cart/actions");
var PickupTime = function (_a) {
    var setIsShowSchedule = _a.setIsShowSchedule;
    var t = (0, react_i18next_1.useTranslation)().t;
    var dispatch = (0, react_redux_1.useDispatch)();
    var _b = (0, react_1.useState)(''), schedule = _b[0], setSchedule = _b[1];
    var pickupTime = (0, react_redux_1.useSelector)(function (state) { return ({
        pickupTime: state.cart.pickupTime,
    }); }).pickupTime;
    var lastTime = new Date();
    lastTime.setHours(23, 59, 59);
    var day = new Date();
    var currentHours = day.getHours();
    var currentMinute = day.getMinutes();
    if (currentMinute <= 30) {
        currentMinute = 30;
    }
    else {
        currentHours += 1;
        currentMinute = 0;
    }
    if (currentHours >= 24) {
        currentHours = 0;
    }
    var hours = [];
    var time = new Date();
    time.setHours(currentHours, currentMinute, 0);
    while (time < lastTime) {
        hours.push(new Date(time));
        time.setHours(time.getHours(), time.getMinutes() + 30);
    }
    var options = [];
    hours.forEach(function (date) {
        var firstTime = date.getHours() + ':' + (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
        var secondTimeMinutes = (Number((date.getMinutes() < 10 ? '0' : '') + date.getMinutes()) + 30);
        var secondTime = (secondTimeMinutes === 60 ? date.getHours() + 1 : date.getHours()) + ':' + (secondTimeMinutes === 60 ? "00" : secondTimeMinutes);
        options.push("".concat(firstTime, " - ").concat(secondTime));
    });
    var onChangePickupTime = function (value) {
        dispatch((0, actions_1.cartChangeAttribute)('pickupTime', value));
        setIsShowSchedule(false);
    };
    var onChangeSchedule = function (e) { return setSchedule(e.target.value); };
    (0, react_1.useEffect)(function () {
        if (pickupTime) {
            setSchedule(pickupTime);
        }
    }, [pickupTime]);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "checkout-table-container" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "checkout-table-container-header" }, { children: [(0, jsx_runtime_1.jsx)(fa_1.FaChevronDown, { size: 22, onClick: function () { return setIsShowSchedule(false); }, cursor: "pointer" }), (0, jsx_runtime_1.jsx)("h3", __assign({ className: "checkout-table-container-title" }, { children: t('Scheduled Pick-up') }))] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "checkout-table-container-select" }, { children: options.map(function (item) {
                    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("input", { className: "checkout-table-container-select-input", id: item, type: "radio", name: "table-number", defaultChecked: item === pickupTime, value: item, onChange: onChangeSchedule }, item), (0, jsx_runtime_1.jsx)("label", __assign({ className: "checkout-table-container-select-label", htmlFor: item }, { children: item }))] }));
                }) })), (0, jsx_runtime_1.jsx)("button", __assign({ className: "custom-button checkout-table-container-confirm-button", onClick: function () { return onChangePickupTime(schedule); } }, { children: t("Confirm") }))] })));
};
exports.default = PickupTime;
